import { Col, Icon, Modal, Row, Tooltip } from 'antd';
/* eslint-disable react/no-this-in-sfc */
import arrayMove from 'array-move';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import {
  SortableContainer,
  SortableElement,
} from 'react-sortable-hoc';
import { bindActionCreators } from 'redux';
import Loader from 'src/components/common/Loader';
import TaxWarning from 'src/components/common/TaxWarning';
import CustomColumnsModal from 'src/components/pages/LTL/CustomColumnsModal';
import { InquiryModes } from 'src/Library/Constants';
import { applyFilter, resetFilters, setFilter } from '../../../../actions/inquiryShipperActionsBids';
import CompareBidsCard from '../Cards/CompareBidsCard';
import ShipperBidMapCard from '../Cards/ShipperBidMapCard';
import { getBidTotal, getUnitByMode } from '../InquiryUtils';
import { tokens } from 'src/design-system';
const bidCustomise = require('src/assets/images/bidCustomise.svg');

const styles = theme => ({
  modal: {
    top: 0,
    minWidth: '100%',
    '& .ant-modal-body': {
      padding: 0,
      minHeight: '600px',
    },
    '& .ant-modal-close': {
      display: 'none',
    },
    '& .ant-modal-header':{
      padding: '0px 20px 10px 20px',
    },
  },
  InquiryNumber: {
    color: '#262626',
    fontSize: `${tokens.fontSize.h2}px`,
    fontWeight: tokens.fontWeight.semibold,
    marginLeft: '21px',
    marginTop: '22px',
  },
  bidInfo: {
    marginLeft: '4px',
    fontSize: `${tokens.fontSize.caption}px`,
    color: '#262626',
    fontStyle: 'italic',
  },
  headerRight: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  infoIcon: {
    display: 'flex',
    alignSelf: 'center',
    color: '#FFC104',
    fontSize: `${tokens.fontSize.small}px`,
  },
  generalKeys: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  detailsLabels: {
    fontSize: `${tokens.fontSize.body}px`,
    color: '#595959',
    fontWeight: tokens.fontWeight.semibold,
    paddingBottom: '15px',
    marginBottom: 0,
  },
  labels: {
    borderBottom: '1px solid #D9D9D9',
    padding: '15px 10px 0px 2px',
  },
  totalPrice: {
    backgroundColor: '#00628B',
    color: tokens.colors.bgWhite,
    fontSize: '21px',
    padding: '11px 20px',
  },
  customiseBidsIcon: {
    height: '21px',
    marginLeft: '20px',
    cursor: 'pointer',
  },
  labelKeys: {
    fontSize: `${tokens.fontSize.body}px`,
    padding: '7px 0px 9px 0px',
    marginBottom: 0,
    color: '#595959',
    width: '100%',
    maxWidth: '100',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    textAlign: 'right'
  },
  modalLabels: {
    boxShadow: '2px 1px 2px 0px rgba(217,217,217,0.5)',
    borderRight: '1px solid #D9D9D9',
    zIndex: 1,
  },
});
class CompareBidsModal extends React.Component<any, any> {
  state:any = {
    customiseBidModalVisible: false,
    allBidsForInquiry: [],
    columns: [],
  };

  componentDidMount() {
    this.setState({
      allBidsForInquiry: this.props.allBidsForInquiry,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isLoading) {
      this.setState({
        allBidsForInquiry: this.props.allBidsForInquiry,
      });
    }
  }

  getContainerType = (key) => {
    const { containerTypes } = this.props;
    if (!key || !containerTypes) return;
    const type = containerTypes.filter(item => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  getCreationDate = () => {
    const { cardData: { createdAt } } = this.props;

    if (!createdAt) return;
    return (
      <div style={{ fontSize: `${tokens.fontSize.small}px`,marginLeft: '20px'}}>
        <Tooltip title="Creation date and time" placement="topRight">
          <Icon type="clock-circle" style={{ marginRight: '12px', fontSize: `${tokens.fontSize.body}px` }} />
        </Tooltip>
        <span style={{ color: '424242' }}>
          {`${moment(createdAt).format('DD MMMM, YYYY | HH:mm')}Hrs`}
        </span>
      </div>
    );
  }

  getDeadline = () => {
    const { cardData: data } = this.props;
    const deadline = `${moment(data.deadline).format('DD MMMM, YYYY | HH:mm')}Hrs`;
    let deadlineString = deadline;
    let deadlineColor = '#424242';
    let isDeadlineNear = false;
    if ((moment(data.deadline) >= moment())) {
      if (moment(data.deadline) < moment().add(2, 'days')) {
        isDeadlineNear = true;
        const now = moment();
        const closingDate = moment(data.deadline);
        const difference = moment.duration(closingDate.diff(moment(now)));
        const hours = difference.asHours().toFixed(0);
        deadlineString = `${hours} hours left`;
        if (parseInt(hours, 10) <= 1) {
          const minutes = difference.asMinutes().toFixed(0);
          deadlineString = `${minutes} minutes left`;
        }
        deadlineColor = '#F5222D';
      }
    }

    if (!deadline) return;

    return <div style={{ fontSize: `${tokens.fontSize.small}px`, color: `${deadlineColor}`,marginLeft: '20px' }}>
      <Tooltip title={isDeadlineNear ? deadline : ''}>
        <Icon type="hourglass" style={{ marginRight: '11px', fontSize: `${tokens.fontSize.body}px` }} />
        <span>{deadlineString}</span>
      </Tooltip>
    </div>;
  }
  
  renderCompareBidHeaderModal = () => {
    const { classes, handleCancel, cardData, renderFilters, renderDownload,
    downloadRequest } = this.props;
    return <span style={{ display: 'flex' }}>
      <Icon type="close" onClick={handleCancel} style={{ cursor: 'pointer', fontSize: `${tokens.fontSize.h2}px`,
        marginTop: '30px' }} />
     <div style={{ display: 'flex', width: '22%', justifyContent: 'space-between' }}>
      <div style={{width: '100%' }}>
        <div style={{ marginTop: '10px' , justifyContent: 'space-between' }}>
          <span className={classes.InquiryNumber}>{cardData.referenceNumber}</span>
        </div>
        {this.getCreationDate()}
        {this.getDeadline()}
      </div>
    </div>
      <Row style={{ width: '100%' }}>
        <Col span={14} style={{ paddingLeft: '10%', marginTop: '30px' }}>{renderFilters()}</Col>
        <Col span={10} className={classes.headerRight}>
          <Icon type="exclamation-circle" className={classes.infoIcon}
            theme="filled" />
          <span className={classes.bidInfo}>
            Bids can be dragged and dropped to compare more effectively</span>
          <span style={{ marginLeft: '18px', fontSize: '24px', color: '#595959' }}>
            {renderDownload(downloadRequest)}</span>
          <Tooltip title="Customise Bids" placement="bottomRight">
            <img className={classes.customiseBidsIcon}
              src={bidCustomise} onClick={() => this.showCustomiseBidModal()} />
          </Tooltip>
        </Col>
      </Row>
      <CustomColumnsModal isVisible={this.state.customiseBidModalVisible}
        fullColumnList={this.generateFullColumnList()}
        columnsToShow={this.generateFullColumnList()}
        isBidComparisonCustomize={this.state.customiseBidModalVisible}
        onModalok={this.handleCustomiseBidok}
        onModalClose={this.handleCustomiseBidClose}
      ></CustomColumnsModal>
    </span >;
  }

  handleCustomiseBidok = (columns) => {
    const bidData = columns.map((column) => {
      const bid = this.props.allBidsForInquiry.find(bid => bid.id === column);
      return bid;
    });
    this.setState({
      customiseBidModalVisible: false,
      allBidsForInquiry: bidData,
    });
  }

  handleCustomiseBidClose = () => {
    this.setState({
      customiseBidModalVisible: false,
    });
  }

  showCustomiseBidModal = () => {
    this.setState({
      customiseBidModalVisible: true,
    });
  }

  renderKeys = (keys) => {
    const { classes } = this.props;
    return keys.map(item => {
      const toRender = item instanceof Object ? (item.isNewCharge ? item.name.toLowerCase() : item.name) : item;
      return (
        <Tooltip title={toRender} placement="topRight" mouseEnterDelay={0.4}>
          <p className={classes.labelKeys}>
            {
              toRender
            }
          </p>
        </Tooltip>
      )
    }
    );
  }

  getColumnHeight = (keys) => {
    return this.renderKeys(keys) && this.renderKeys(keys) instanceof Array ?
    `${51 + this.renderKeys(keys).length * 37}px` : undefined;
  }

  renderLabels = (label, keys) => {
    const { classes } = this.props;
    const colHeight = this.getColumnHeight(keys);
    return <>
      {label ? <div className={classes.labels} style={{ height: colHeight }}>
        <p className={classes.detailsLabels}>{label}</p>
        <div className={classes.generalKeys}>{this.renderKeys(keys)}</div>
      </div> : undefined}
    </>;
  }

  renderTotal = () => {
    const { classes } = this.props;
    return <div className={classes.totalPrice}>
      Total Price
    </div>;
  }

  getLabel = (label) => {
    return label &&
      label.values &&
      label.values;
  }

  getKeys = (allBidsForInquiry, charges, label) => {
    return allBidsForInquiry.map((item) => {
      item.chargeDetails &&
      this.getLabel(item.chargeDetails[label])?.map((data) => {
        const chargesInLowerCase = charges?.map(item => item.name?.toLowerCase()?.trim());
        if (chargesInLowerCase.indexOf(data.name?.toLowerCase()?.trim()) === -1) {
          return charges.push({
            name: data.name,
            isNewCharge: data.isNewCharge,
          });
        }
      });
    });
  }

  getGeneralLabels = (label, value, keys) => {
    if ((label && label.length > 0) || (typeof label === 'object' && !isEmpty(label))) {
      if (keys.indexOf(value) === -1) {
        keys.push(value);
      }
    }
  }

  getFreeLabels = (label, value, keys) => {
    if ((label?.cfsFreeDays >= 0 ||
        label?.originFreeDays >= 0 ||
        label?.demurrageFreeDays >= 0 ||
        label?.combinedFreeDays >= 0)
      ) {
      if (keys.indexOf(value) === -1) {
        keys.push(value);
      }
    }
  }

  getLabelKeys = (allBidsForInquiry, generalDetailsKeys, freeDaysKeys) => {
    const { cardData } = this.props;
    const trailerDefaultValues = ['Vendor Rating', 'Bid Validity'];
    if (cardData?.mode === InquiryModes.DOMESTIC || cardData?.mode === InquiryModes.RPTL) {
      trailerDefaultValues.push('Stuffing Location');
      trailerDefaultValues.push('Delivery Location');
      trailerDefaultValues.push('Transit Days');
    }
    const showPod = cardData?.otherDetails?.allowVendorToSpecifyDestination;
    const nonTrailerDefaultValues = showPod ? ['Vendor Rating', 'Carrier', 'Bid Validity', 'POL', 'POD', 'Transit Days'] 
      : ['Vendor Rating', 'Carrier', 'Bid Validity', 'POL', 'Transit Days'];
    [InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL].includes(cardData?.mode) ? generalDetailsKeys.push(...trailerDefaultValues) :
    generalDetailsKeys.push(...nonTrailerDefaultValues);

    for (let i = 0; i < allBidsForInquiry.length; i = i + 1) {
      allBidsForInquiry[i].otherDetails &&
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.siCutOff,
        'SI Cut Off', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.etd,
        'ETD', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.eta,
        'ETA', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.schedule,
        'Schedule', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.route,
        'Route', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.alternateVesselSchedule,
        'Alternate Vessel Schedule', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.allowedCargoWeight,
        'Allowed Cargo Weight (Kg)', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.transshipmentVia,
        'Transshipment', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.roundTripTime,
        'Round Trip Time', generalDetailsKeys);
      this.getGeneralLabels(allBidsForInquiry[i].otherDetails.detentionCostPerDay,
        'Detention Cost Per Day', generalDetailsKeys);
      if (allBidsForInquiry[i]?.otherDetails?.originFreeDays >= 0) {
        if (freeDaysKeys.indexOf('Origin Free Days') === -1) {
          freeDaysKeys.push('Origin Free Days');
        }
      }
      if (allBidsForInquiry[i]?.otherDetails?.demurrageFreeDays >= 0) {
        if (freeDaysKeys.indexOf('Demurrage Free Days') === -1) {
          freeDaysKeys.push('Demurrage Free Days');
        }
      }
      if (allBidsForInquiry[i]?.otherDetails?.detentionFreeDays >= 0) {
        if (freeDaysKeys.indexOf('Detention Free Days') === -1) {
          freeDaysKeys.push('Detention Free Days');
        }
      }
      if (allBidsForInquiry[i]?.otherDetails?.cfsFreeDays >= 0) {
        if (freeDaysKeys.indexOf('CFS Free Days') === -1) {
          freeDaysKeys.push('CFS Free Days');
        }
      }
      if (allBidsForInquiry[i]?.otherDetails?.combinedFreeDays >= 0) {
        if (freeDaysKeys.indexOf('Combined Free Days') === -1) {
          freeDaysKeys.push('Combined Free Days');
        }
      }
    }
    return generalDetailsKeys;
  }

  getLabels = (allBidsForInquiry, labelKey) => {
    let label;
    for (let i = 0; i < allBidsForInquiry.length; i = i + 1) {
      if (allBidsForInquiry[i].chargeDetails && allBidsForInquiry[i].chargeDetails[labelKey]
        && allBidsForInquiry[i].chargeDetails[labelKey].values
        && allBidsForInquiry[i].chargeDetails[labelKey].values.length > 0) {
        label = allBidsForInquiry[i].chargeDetails[labelKey].name;
        return label;
      }
    }
  }

  generateFullColumnList = () => {
    const fullColumnList: any = [];
    const { allBidsForInquiry } = this.props;
    for (let i = 0; i < allBidsForInquiry.length ; i = i + 1) {
      !allBidsForInquiry[i].isConfirmationRequiredForNegotiatedBid &&
      fullColumnList.push({
        id: `${allBidsForInquiry[i].id}`,
        column_id: `Rank${i}`,
        pretty_name: `Rank ${allBidsForInquiry[i].rank}`,
        column_price: `${allBidsForInquiry[i].totalPerUnit &&
        allBidsForInquiry[i].totalPerUnit.currency &&
        this.props.currency[allBidsForInquiry[i].totalPerUnit.currency]}
        ${allBidsForInquiry[i].totalPerUnit && allBidsForInquiry[i].totalPerUnit.amount &&
          getBidTotal(allBidsForInquiry[i].totalPerUnit.amount)}`,
      });
    }
    return fullColumnList;
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ allBidsForInquiry }) => ({
      allBidsForInquiry: arrayMove(allBidsForInquiry, oldIndex, newIndex),
    }));
  }

  getLabelName = (charge) => {
    return charge.map(item => item.name);
  }

  render() {
    const { classes, visible, handleCancel, cardData,
      renderNoData, refreshInquiryData, isLoading } = this.props;
    const { allBidsForInquiry } = this.state;
    const generalDetailsKeys: any = [];
    const freeDaysKeys: any = [];
    this.getLabelKeys(allBidsForInquiry, generalDetailsKeys, freeDaysKeys);
    const originCharges : any = [];
    this.getKeys(allBidsForInquiry, originCharges, 'originCharges');
    originCharges?.length > 0 && originCharges.push({name: 'Sub Total of Origin Charges', isNewCharge: false});

    const destinationCharges : any = [];
    this.getKeys(allBidsForInquiry, destinationCharges, 'destinationCharges');
    destinationCharges?.length > 0 && destinationCharges.push({name: 'Sub Total of Destination Charges', isNewCharge: false});

    const freightCharges : any = [];
    this.getKeys(allBidsForInquiry, freightCharges, 'freightCharges');
    freightCharges?.length > 0 && freightCharges.push({name: InquiryModes.DOMESTIC === cardData?.mode ? 'Sub Total of Transport Charges' : 'Sub Total of Freight Charges', isNewCharge: false});

    const topBidData = this.state.allBidsForInquiry.find((bid) => bid.rank === '1');
    const ListItem = (record: any) => {
      return (
        <div style={{ display: 'flex', paddingLeft: '5px' }}>
          {
            this.state.allBidsForInquiry.filter(
              item => item.id === record.record.value.id)
              .map((item) => {
                return !item.isConfirmationRequiredForNegotiatedBid &&
                  <CompareBidsCard cardData={item} key={item.id} inquiryId={cardData.id}
                    inquiryData={cardData}
                    topBidData={topBidData}
                    captureReasonForNonL1Bid={this.props.captureReasonForNonL1Bid}
                    originChargesValue={this.getLabelName(originCharges)}
                    destinationChargesValue={this.getLabelName(destinationCharges)}
                    freightChargesValue={this.getLabelName(freightCharges)}
                    generalDetailsKeys={generalDetailsKeys}
                    bidData={allBidsForInquiry}
                    freeDaysKeys={freeDaysKeys}
                    getColumnHeight={this.getColumnHeight} 
                    refreshInquiryData={refreshInquiryData}
                    exchangeRateDate={cardData?.exchangeRate?.referenceDate}
                  />;
              })
            }
        </div>
      );
    };

    const SortableItem = SortableElement((props: any) => <ListItem record={props} />);
    const SortableList = SortableContainer((props: any) => {
      return (
        <ul style={{ padding: 0, display: 'flex', margin: 0 }}>
          {this.state.allBidsForInquiry.map((value, index) => (
            <SortableItem key={`item-${index}`} index={index} value={value} />
          ))}
        </ul>
      );
    });
    return <Modal className={classes.modal}
      title={this.renderCompareBidHeaderModal()}
      visible={visible}
      onCancel={handleCancel}
      footer=""
    >
      <Row style={{ backgroundColor: '#FCFCFC' }}>
        {isLoading ? <Loader zIndex={1000} top={200} /> : (allBidsForInquiry && allBidsForInquiry.length !== 0 ?
          <><Col span={7} className={classes.modalLabels}>
            <div style={{ borderBottom: '1px solid #D9D9D9', padding: '0 0 24px 15px',
              height: '172px' }}>
            <div style={{ height: '95px', paddingLeft: '15px' }}>
              {/* TODO: clean code - ShipperBidMapCard should be independant of
              lclPackageTypes and others  */}
              <ShipperBidMapCard
                cardData={cardData}
                containerTypes={this.props.containerTypes}
                lclPackageTypes={this.props.lclPackageTypes}
                getContainerType={this.getContainerType}
                dividerColor="#D9D9D9"
                isCompareBidsModal={true}>
              </ShipperBidMapCard>
            </div>
            <TaxWarning unit={getUnitByMode(cardData.mode)}
              style={{ paddingTop: '30px' }} compareBidsStyle={true}></TaxWarning>
            </div>
            <div style={{ padding: "0px 16px" }}>
              {this.renderLabels('General Details', generalDetailsKeys)}
              {this.renderLabels(this.getLabels(allBidsForInquiry, 'freightCharges'), freightCharges)}
              {this.renderLabels(this.getLabels(allBidsForInquiry, 'originCharges'), originCharges)}
              {this.renderLabels(this.getLabels(allBidsForInquiry,
                'destinationCharges'), destinationCharges)}
              {freeDaysKeys.length > 0 && this.renderLabels('Free Days', freeDaysKeys)}
            </div>
            {this.renderTotal()}
          </Col>
          <Col span={17} style={{ overflow: 'auto' }}>
            <SortableList
              distance={1}
              axis="x"
              items={this.state.allBidsForInquiry} onSortEnd={this.onSortEnd}
              helperClass="sortableHelper" />
          </Col>
          </>
          : renderNoData())}
    </Row>
  </Modal>;
  }
}

const mapStateToProps = ({ inquiryShipperBidsReducer, masterData, staticData,
  inquiryReducer }) => ({
    filters: inquiryShipperBidsReducer.selectedFilters,
    appliedFilters: inquiryShipperBidsReducer.appliedFilters,
    isLoading: inquiryShipperBidsReducer.isLoading,
    pagination: inquiryShipperBidsReducer.pagination,
    permission: masterData.permissions.INQUIRY_BIDDING_ALL_ACTIONS,
    containerTypes: staticData.containerTypesKeyVal,
    currency: masterData.currencySymbols,
    lclPackageTypes: inquiryReducer.masterData.lclPackageTypes,
    userCurrency: masterData?.userData?.user_metadata?.user_currency,
  });

const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilter,
  applyFilter,
  resetFilters,
}, dispatch));
export default injectSheet(styles)(connect(mapStateToProps, mapDispatchToProps)(CompareBidsModal));
